// Mobile Menu — accordion-style nested navigation
class MobileMenu {
  constructor() {
    this.mobileMenu = document.querySelector('[data-component="mobile-menu"]');
    this.menuButton = document.querySelector('[data-action="open-menu"]');
    this.menuOverlay = document.querySelector('[data-component="menu-overlay"]');
    this.isOpen = false;

    if (!this.mobileMenu || !this.menuButton) return;

    this.bindEvents();
    this.initAria();
  }

  initAria() {
    this.menuButton.setAttribute('aria-expanded', 'false');
    this.menuButton.setAttribute('aria-controls', this.mobileMenu.id || 'mobile-menu');
    this.mobileMenu.setAttribute('aria-hidden', 'true');
  }

  bindEvents() {
    this.menuButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.isOpen ? this.close() : this.open();
    });

    this.menuOverlay?.addEventListener('click', () => this.close());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) this.close();
    });

    const desktopMql = window.matchMedia('(min-width: 1024px)');
    const handleBreakpoint = (e) => { if (e.matches && this.isOpen) this.close(); };
    desktopMql.addEventListener ? desktopMql.addEventListener('change', handleBreakpoint) : desktopMql.addListener(handleBreakpoint);

    this.mobileMenu.addEventListener('click', (e) => {
      const trigger = e.target.closest('.mobile-nav-trigger');
      if (trigger) {
        this.toggleItem(trigger);
        return;
      }

      const link = e.target.closest('a[href*="#"]');
      if (link) {
        const url = new URL(link.href);
        if (!url.hash) return;
        if (url.pathname !== window.location.pathname) return;
        e.preventDefault();
        this.close();
        setTimeout(() => {
          const target = document.querySelector(url.hash);
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 350);
      }
    });
  }

  toggleItem(trigger) {
    const item = trigger.closest('.mobile-nav-item');
    if (!item) return;

    const panel = item.querySelector('.mobile-nav-panel');
    const isOpen = item.classList.contains('is-open');

    if (isOpen) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      requestAnimationFrame(() => {
        panel.style.maxHeight = '0px';
        item.classList.remove('is-open');
      });
      trigger.setAttribute('aria-expanded', 'false');
    } else {
      item.classList.add('is-open');
      panel.style.maxHeight = '0px';
      requestAnimationFrame(() => {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      });
      trigger.setAttribute('aria-expanded', 'true');
    }
  }

  open() {
    this.mobileMenu.classList.add('active');
    document.body.style.overflow = 'hidden';
    this.menuButton.setAttribute('data-menu-open', 'true');
    this.menuButton.setAttribute('aria-expanded', 'true');
    this.mobileMenu.setAttribute('aria-hidden', 'false');

    const header = document.getElementById('site-header');
    header?.classList.add('mobile-menu-open');

    if (this.menuOverlay) {
      this.menuOverlay.classList.add('active');
      this.menuOverlay.setAttribute('aria-hidden', 'false');
    }

    this.isOpen = true;
  }

  close() {
    this.mobileMenu.classList.remove('active');
    document.body.style.overflow = '';
    this.menuButton.setAttribute('data-menu-open', 'false');
    this.menuButton.setAttribute('aria-expanded', 'false');
    this.mobileMenu.setAttribute('aria-hidden', 'true');

    const header = document.getElementById('site-header');
    header?.classList.remove('mobile-menu-open');

    if (this.menuOverlay) {
      this.menuOverlay.classList.remove('active');
      this.menuOverlay.setAttribute('aria-hidden', 'true');
    }

    this.isOpen = false;

    setTimeout(() => {
      this.mobileMenu.querySelectorAll('.mobile-nav-item.is-open').forEach((item) => {
        const panel = item.querySelector('.mobile-nav-panel');
        if (panel) panel.style.maxHeight = '';
        item.classList.remove('is-open');
        const trigger = item.querySelector('.mobile-nav-trigger');
        trigger?.setAttribute('aria-expanded', 'false');
      });
    }, 300);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.mobileMenu = new MobileMenu();
});
